import { BaseRepresentativeClientEntity } from 'api/types/entity';
import { TFunc } from 'libs/i18n';
import {
  parseBiographyInitialValue,
  parsePepConnectionInitialValue,
  parseBaseDebtsInitialValue,
  parseAddressValue,
  parseResidentialAddressValue,
  parseTaxResidencesValue,
  parseCitizenshipsValue,
} from 'modules/client/common/helpers';

import { RepresentativeFormType } from '../../forms/representativeForm';

import { parseBasisForRepresentation } from './parseBasisForRepresentation';
import { parseIdentityDocumentInitialValue } from './parseIdentityDocumentInitialValue';

export const getBaseRepresentativeInitialValue = (
  client: BaseRepresentativeClientEntity,
  t: TFunc
): RepresentativeFormType => ({
  reasonChange: { reason: '' },
  contacts: {
    email: client.email,
    phone: client.phone,
  },

  personalData: {
    firstName: client.firstName,
    lastName: client.lastName,
    middleName: client.middleName ?? '',
    dateOfBirth: client.dateOfBirth,
    gender: client.gender
      ? {
          label: t(`client.client.personalData.gender.${client.gender}`),
          value: client.gender,
        }
      : undefined,
  },

  citizenships: parseCitizenshipsValue(client.citizenships),

  taxResidences: parseTaxResidencesValue(client.taxResidences),

  registrationAddress: parseAddressValue(client.registrationAddress),
  residentialAddress: parseResidentialAddressValue(client.residentialAddress),

  placeOfBirth: {
    country: client.placeOfBirth?.country ?? null,
    locality: client.placeOfBirth?.locality ?? '',
  },

  biography: parseBiographyInitialValue(t, client.biography),

  bankAccounts: client.bankAccounts?.map((v) => ({
    country: v.country || null,
    swiftCode: v.swiftCode,
  })) || [{ country: null, swiftCode: '' }],

  pepConnection: parsePepConnectionInitialValue(client.pepConnection, t),

  debts: parseBaseDebtsInitialValue(client.debts, t),

  activity: {},

  basisForRepresentation: parseBasisForRepresentation(
    client.basisForRepresentation
  ),
  additionalDocumentsFiles: client.additionalInformationFiles,

  identityDocument: parseIdentityDocumentInitialValue(t, client),
});
